import React from 'react'
import { Box } from '@chilipiper/design-system'

export const Spacer = () => <Box flex={1} />
